
export function getPermissionPreset() {
  const v = localStorage.getItem("permission_preset");
  return (v || "").toUpperCase(); // "CLINICAL" | "FRONTDESK" | "BOTH" | ""
}

export function isOwner() {
  return localStorage.getItem("is_owner") === "true";
}
export function isAdmin() {
  return localStorage.getItem("is_admin") === "true";
}
export function isOutboundEnabled() {
  return localStorage.getItem("outbound_calls_enabled") === "true";
}
/** The clinic has a scheduling (PMS) integration behind it. */
export function hasScheduling() {
  return localStorage.getItem("has_scheduling") === "true";
}
/**
 * Reactivation is for clinics that can place outbound calls; admins always
 * pass. A PMS is no longer required: a clinic without one runs transfer
 * campaigns, and the page hides the PMS-backed call list itself. The backend
 * re-checks every request.
 */
export function canSeeReactivation() {
  return isAdmin() || isOutboundEnabled();
}
/**
 * Transfer campaigns are switched on per clinic by an admin, and the flag is
 * the only thing that opens them: there is no admin bypass. An admin starting
 * a transfer campaign on a booking clinic would dial the booking agent while
 * the webhook skips booking settlement, so patients would hear "you're booked"
 * with no appointment behind it. The backend applies the same rule.
 */
export function canUseTransferCampaigns(clinic) {
  // The permission belongs to a CLINIC. A clinic user's own verdict came with
  // sign-in; an admin has no clinic of their own, so for them it is read off
  // the clinic they picked in the tab row (the admin clinic list carries the
  // flag). Without a row, the sign-in flag decides.
  if (clinic && typeof clinic === "object") return Boolean(clinic.transfer_campaigns_enabled);
  return localStorage.getItem("transfer_campaigns_enabled") === "true";
}

/** The transfer permission for whoever is looking: the admin's selected clinic row, else the sign-in flag. */
export function transferAllowedFor({ isAdmin: admin, clinics = [], clinicId } = {}) {
  if (!admin) return canUseTransferCampaigns();
  const row = clinics.find((c) => c.id === clinicId);
  return row ? canUseTransferCampaigns(row) : false;
}
/**
 * moduleKey: "clinical" | "frontdesk"
 */
export function canAccess(moduleKey) {
  if (isOwner()) return true;

  const preset = getPermissionPreset();

  if (preset === "BOTH") return true;
  if (moduleKey === "clinical") return preset === "CLINICAL";
  if (moduleKey === "frontdesk") return preset === "FRONTDESK";

  return false;
}
